// Ubicación en el repo: src/components/SchedulingSettings.jsx
// Sub-pestaña "Agenda online" de Configuración (29-sep-2026, DECISIONS.md
// #124, pedido de Nicolás). Un solo interruptor por ahora: si los correos
// de confirmación/recordatorio de hora incluyen o no el link de
// cancelación online por parte del paciente. Se apagó por defecto (algunos
// pacientes lo usaban a propósito para des-ordenar la agenda: cancelaban
// su hora y sacaban otra por su cuenta en la página pública, sin pasar por
// la clínica) — el código del flujo de cancelación queda intacto, este
// interruptor solo controla si se ofrece o no.
import { useState } from 'react';
import { updateCancelLinkEnabled } from '../lib/clinicSettings';

export default function SchedulingSettings({ settings, isAdmin, actorId, onSaved }) {
  const [enabled, setEnabled] = useState(!!settings.cancelLinkEnabled);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  async function handleSave() {
    setError('');
    setSaving(true);
    try {
      await updateCancelLinkEnabled(enabled, actorId);
      onSaved({ ...settings, cancelLinkEnabled: enabled });
      setSaved(true);
    } catch (err) {
      setError(err.message || 'No se pudo guardar el ajuste.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="patients-page">
      <h1>Agenda online</h1>
      <p className="text-muted" style={{ marginBottom: 18 }}>
        Controla si los correos de confirmación de hora y de recordatorio le ofrecen al paciente un link para
        cancelar su propia cita.
      </p>

      {!isAdmin && <p className="text-muted">Solo un Admin puede editar este ajuste.</p>}

      <div style={{ opacity: isAdmin ? 1 : 0.6, pointerEvents: isAdmin ? 'auto' : 'none' }}>
        <label className="field" style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
          <input
            type="checkbox"
            checked={enabled}
            onChange={(e) => {
              setEnabled(e.target.checked);
              setSaved(false);
            }}
          />
          <span>Permitir que el paciente cancele su hora desde el correo</span>
        </label>
        <p className="field-hint" style={{ marginTop: 6 }}>
          Con esto apagado, los correos de confirmación y recordatorio dejan de mostrar el link de
          cancelación — en su lugar invitan al paciente a llamar directamente a la sucursal si necesita
          cancelar o reagendar. Si alguien todavía tiene guardado un correo viejo con el link, al abrirlo va a
          ver un aviso de que la función está desactivada, en vez de un error. No se borra nada del sistema —
          es solo este interruptor, se puede volver a activar cuando quieras.
        </p>
      </div>

      {error && <p className="auth-error">{error}</p>}
      {saved && !error && <p className="text-muted">Guardado.</p>}

      {isAdmin && (
        <div className="modal-actions" style={{ justifyContent: 'flex-start' }}>
          <button type="button" className="button-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Guardando…' : 'Guardar'}
          </button>
        </div>
      )}
    </div>
  );
}
